import * as yup from 'yup';

export const initialValues = {
  site: '',
  countDate: null,
};

export const validationSchema = yup.object().shape({
  site: yup.string().required('Site is required'),
  countDate: yup.string().nullable().required('Count date is required'),
});
